module.exports = __webpack_public_path__ + "placa_moveis_10x_s_1x9_carne.png?e88e90b75b9aac6745726346e0b5fc80";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_moveis_10x_s_1x9_carne.png
// module id = 127
// module chunks = 0